<span
  ref="eMenu"
  *ngIf="params.enableMenu"
  #menuButton
  (click)="onMenuClicked()"
  class="ag-header-icon ag-header-cell-menu-button"
>
  <span class="ag-icon ag-icon-menu" unselectable="on" role="presentation"></span>
</span>

<div ref="eLabel" class="ag-header-cell-label" role="presentation" (click)="onSortRequested(sorted)">
  {{ params.displayName }}
  <button
    *ngIf="!params.hideAllJobsButton"
    y42StopPropagation
    class="header-job-btn"
    (click)="openJobsDialog()"
    [attr.data-test]="'job-status-header-renderer-button-all-files'"
  >
    All Jobs
  </button>
  <span
    ref="eFilter"
    *ngIf="state.filterActive"
    class="ag-header-icon ag-header-label-icon ag-filter-icon"
    aria-hidden="true"
  >
    <span class="ag-icon ag-icon-filter" unselectable="on" role="presentation"></span>
  </span>
  <span ref="eSortOrder" class="ag-header-icon ag-header-label-icon">
    <span *ngIf="params.enableSorting" (click)="onSortRequested(sorted)" class="customSortDownLabel">
      <fa-icon *ngIf="state.sortedIcon" [icon]="state.sortedIcon"></fa-icon>
    </span>
  </span>
</div>
